<template>
  <div id="room-manegement">Room</div>
</template>

<script>
export default {};
</script>

<style></style>
